import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-medal-star",
  "use": "icon-si-glyph-medal-star-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-medal-star\" id=\"icon-si-glyph-medal-star\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>942</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(3.000000, 0.000000)\" fill=\"#434343\">\n            <path d=\"M5.007,5.996 L6.078,9.016 L9.618,9.016 L6.74,11.318 L7.834,14.807 L4.969,12.65 L2.105,14.807 L3.199,11.318 L0.349,9.016 L3.889,9.016 L5.007,5.996 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M5.007,1.947 L7.283,7.986 L8.5,7.986 L8.969,1.367 C8.969,1.367 9.151,0.041 7.768,0.041 L2.252,0.041 C0.891,0.041 1.017,1.346 1.017,1.346 L1.505,7.987 L2.734,7.987 L5.007,1.947 L5.007,1.947 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-medal-star.svg
// module id = JM37
// module chunks = 62